var _path, _path2, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOcticonCopy24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3203 13.5013C11.3203 14.1453 10.7976 14.668 10.1536 14.668H2.50298C1.85898 14.668 1.33631 14.1453 1.33631 13.5013V5.83597C1.33631 5.52655 1.45923 5.2298 1.67802 5.01101C1.89681 4.79222 2.19356 4.6693 2.50298 4.6693H10.1536C10.4631 4.6693 10.7598 4.79222 10.9786 5.01101C11.1974 5.2298 11.3203 5.52655 11.3203 5.83597V13.5013ZM10.1536 13.668C10.1978 13.668 10.2402 13.6504 10.2715 13.6192C10.3028 13.5879 10.3203 13.5455 10.3203 13.5013V5.83597C10.3203 5.7433 10.2456 5.6693 10.1536 5.6693H2.50298C2.45878 5.6693 2.41638 5.68686 2.38513 5.71812C2.35387 5.74937 2.33631 5.79177 2.33631 5.83597V13.5013C2.33631 13.5455 2.35387 13.5879 2.38513 13.6192C2.41638 13.6504 2.45878 13.668 2.50298 13.668H10.1536Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 8.83267C14.672 8.98593 14.6419 9.13771 14.5833 9.27934C14.5247 9.42096 14.4387 9.54965 14.3304 9.65806C14.2221 9.76646 14.0934 9.85246 13.9518 9.91113C13.8102 9.9698 13.6585 10 13.5052 10H12.5019C12.3693 10 12.2421 9.94732 12.1483 9.85355C12.0546 9.75979 12.0019 9.63261 12.0019 9.5C12.0019 9.36739 12.0546 9.24022 12.1483 9.14645C12.2421 9.05268 12.3693 9 12.5019 9H13.5052C13.5494 9 13.5918 8.98244 13.6231 8.95118C13.6543 8.91993 13.6719 8.87754 13.6719 8.83333L13.6685 2.49867C13.6685 2.40667 13.5945 2.332 13.5019 2.332H7.16854C7.12434 2.332 7.08195 2.34956 7.05069 2.38082C7.01943 2.41207 7.00187 2.45446 7.00187 2.49867V3.50533C7.00187 3.63794 6.9492 3.76512 6.85543 3.85889C6.76166 3.95266 6.63448 4.00533 6.50187 4.00533C6.36927 4.00533 6.24209 3.95266 6.14832 3.85889C6.05455 3.76512 6.00187 3.63794 6.00187 3.50533V2.49867C6.00187 2.18925 6.12479 1.8925 6.34358 1.67371C6.56238 1.45492 6.85912 1.332 7.16854 1.332H13.5019C13.8113 1.332 14.108 1.45492 14.3268 1.67371C14.5456 1.8925 14.6685 2.18925 14.6685 2.49867L14.6719 8.83267Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.28906,
    y: 5.71484,
    width: 8,
    height: 8,
    fill: "#D3CCFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcticonCopy24);
export default __webpack_public_path__ + "static/media/octicon_copy-24.a44b79bfb526dd88f315835f3fde7656.svg";
export { ForwardRef as ReactComponent };